<template>
<!-- eslint-disable max-len -->
<div style="position: absolute;">
  <div
    class="choice-bubble"
    :class="{
      right,
      sf: (starfighter),
      native,
      carousel: (decision.type && decision.type === 'choice' && choiceDisplayType === 'carousel'),
      matching,
      multi: (decision.type && decision.type === 'multiselect')
    }"
    :style="{
      'max-height': (decision.choiceBubbleMaxHeightOverride ? decision.choiceBubbleMaxHeightOverride : undefined),
      'min-height': (decision.choiceBubbleMinHeightOverride ? decision.choiceBubbleMinHeightOverride : undefined),
    }"
  >
    <div v-if="starfighter" style="position: fixed; left: 0px; right: 0px; z-index: -1;">
      <div
        v-if="decision.prompt && decision.prompt.trim() !== ''"
        :class="`prompt ${(starfighter) ? 'sf' : 'native'}`"
      >
        <!--
          Never use v-html with end-user generated content, because it's a vector for XSS attacks
          This is what the following line used to be:
          <span>{{decision.prompt}}</span>
        -->
        <span v-html="decision.prompt"></span>
      </div>
    </div>
    <div
      v-if="survey"
      :style="{
        display: 'flex',
        'flex-direction': 'row',
        'justify-content': 'space-between',
        'font-size': '23px',
        color: ((starfighter) ? 'black' : 'white')
      }"
    >
      <div style="margin: 10px 15px;">{{decision.minLabel}}</div>
      <div style="text-align: right; margin: 10px 15px;">{{decision.maxLabel}}</div>
    </div>
    <div
      v-if="decision.type && decision.type === 'multiselect'"
      style="max-height: 390px; overflow: visible; position: relative;"
    >
      <div
        style="padding-bottom: 4px; max-height: 390px; overflow: hidden auto;"
      >
        <div
          :style="`height: ${(45 * displayChoices.length) + 20}px; padding-left: 6px;`"
        >
          <b-form-checkbox-group
            v-model="choices"
            :options="options"
            stacked
            style="transform: translate(50%, 50%) scale(2); overflow: visible !important;"
            :style="checkboxGroupStyle"
          ></b-form-checkbox-group>
        </div>
      </div>
      <button
        v-if="starfighter"
        class="btn"
        style="position: absolute; right: 50px; bottom: 30px; font-size: 180%; height: 50px; padding: 10px;"
        :disabled="decision.multiselectMinChoices ? (choices.length < decision.multiselectMinChoices) : false"
        @click.prevent="() => { onClickChoice(choices); }"
      >
        <span v-html="submitButtonText ? submitButtonText : 'Select'"></span>
      </button>
    </div>
    <div v-else-if="decision.type && decision.type === 'sliders'">
      <div :class="containerClass" :style="containerStyle">
        <template v-if="displayChoices.length > 1">
          <div
            v-for="(choice, idx) in displayChoices"
            :key="`choice-${idx}`"
            :class="`multi-slider-container ${buttonClass}`"
            :style="{
              height: 'fit-content',
              padding: '0px 15px 13px',
              // choice image and showTitle aren't enabled settings for sliders; if that changes, uncomment and test
              // position: (choiceImage(choice) && choice.showTitle) ? 'relative' : undefined,
              // overflow: (choiceImage(choice) && choice.showTitle) ? 'visible' : undefined,
              // 'margin-bottom': (choiceImage(choice) && choice.showTitle) ? '50px' : undefined,
            }"
          >
            <choice-slider
              ref="choiceSlider"
              :choice="choice"
              :idx="idx"
              :decision="decision"
              width="100%"
              title-height="fit-content"

              :background-color="native ? 'white' : 'black'"
              :clock="choice.sliderIsTime"
              :slider-interval="choice.sliderInterval"
              :slider-min="choice.sliderMin"
              :slider-max="choice.sliderMax"
              :color="choice.sliderColor"
              :title="choiceTitle(choice)"
              :display-intervals="choice.sliderDisplayIntervals"
              :no-thumb-or-fill="(slidersBlank && slidersBlank.length > idx) ? slidersBlank[idx] : false"

              @click="() => onSliderInput(idx)"
            />
          </div>
        </template>
        <template v-else>
          <div :style="`display: flex; justify-content: center; width: 100%; height: 100%; height: 150px;`">
            <div
              v-for="(choice, idx) in displayChoices"
              :key="`choice-${idx}`"
              class="single-slider-container"
              :style="!(native) ? 'min-height: 100px;' : ''"
            >
              <choice-slider
                :style="native ? 'margin-top: 0px;' : ''"
                ref="choiceSlider"
                :choice="choice" :idx="idx" :decision="decision" single
                :width="native ? '600px' : '690px'"
                title-height="fit-content"

                :background-color="native ? 'white' : 'black'"
                :clock="choice.sliderIsTime"
                :slider-interval="choice.sliderInterval"
                :slider-min="choice.sliderMin"
                :slider-max="choice.sliderMax"
                :color="choice.sliderColor"
                :title="choiceTitle(choice)"
                :display-intervals="choice.sliderDisplayIntervals"
                :no-thumb-or-fill="(slidersBlank && slidersBlank.length > idx) ? slidersBlank[idx] : false"

                @click="() => onSliderInput(idx)"
              />
            </div>
          </div>
        </template>
      </div>
      <!-- This div is just here to make additional room for the button since it has absolute positioning -->
      <div style="height: 10px;"/>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
      >
        <button
          v-if="!slidersBlank || (slidersBlank.length && slidersBlank.every(sb => !sb))"
          class="btn-choice"
          :style="(native ? 'position: absolute; right: 20px; bottom: 20px;' : 'position: absolute; right: 20px; bottom: 20px;') + ' width: 100px; font-size: 20px; font-weight: 500;'"
          @click.prevent="onSubmitSliders"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Set'"></span>
        </button>
      </transition>
    </div>
    <div v-else-if="decision.type && decision.type === 'scale'">
      <div
        style="
          height: fit-content;
          max-height: 452px;
        "
      >
        <!-- category headers -->
        <div
          style="
            width: 98%;
            padding: 6px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          ></div>
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-header-${c}`"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              white-space: pre-wrap;
              text-align: center;
              padding: 0 10px;
            "
            :style="{
              width: `${categoryColumnWidth}%`,
            }"
          >
            <div v-html="category.displayName || category.name"></div>
          </div>
        </div>
        <!-- choice rows -->
        <div
          v-for="(choice, idx) in displayChoices"
          :key="`choice-${idx}`"
          style="
            width: 98%;
            padding: 3px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
          :style="{
            'background-color': (idx % 2 === 0) ? 'rgba(0,0,0,0.05)' : undefined,
          }"
        >
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: center;
              white-space: pre-wrap;
              text-align: left;
            "
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          >
            <div v-html="choiceTitle(choice)"></div>
          </div>
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-radio-${c}`"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
            "
            :style="{
              width: `${categoryColumnWidth}%`,
            }"
          >
            <b-form-radio
              v-if="choices[idx]"
              v-model="choices[idx].category"
              :aria-label="`${choiceTitle(choice)} ${category.name}`"
              :name="`choice-${idx}-radios`"
              :value="category"
              size="lg"
              style="margin-right: -40px; padding: 0;"
              @change="playChoiceInput"
            ></b-form-radio>
          </div>
        </div>
      </div>
      <!-- This div is just here to make additional room for the button since it has absolute positioning -->
      <div style="height: 60px;"/>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
      >
        <button
          v-if="choices && choices.length && choices.every(c => c.category)"
          class="btn-choice"
          style="position: absolute; right: 20px; bottom: 20px; width: 100px; font-size: 20px; font-weight: 500;"
          @click.prevent="onSubmitScale"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Set'"></span>
        </button>
      </transition>
    </div>
    <div v-else-if="decision.type && decision.type === 'matrix'">
      <div
        style="
          height: fit-content;
          max-height: 452px;
        "
      >
        <!-- category headers -->
        <div
          style="
            width: 98%;
            padding: 6px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          ></div>
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-header-${c}`"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              white-space: pre-wrap;
              text-align: center;
              padding: 0 10px;
            "
            :style="{
              width: `${categoryColumnWidth}%`,
            }"
          >
            <div v-html="category.displayName || category.name"></div>
          </div>
        </div>
        <!-- choice rows -->
        <div
          v-for="(choice, idx) in displayChoices"
          :key="`choice-${idx}`"
          style="
            width: 98%;
            padding: 3px 1%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
          :style="{
            'background-color': (idx % 2 === 0) ? 'rgba(0,0,0,0.05)' : undefined,
          }"
        >
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: center;
              white-space: pre-wrap;
              text-align: left;
            "
            :style="{
              width: `${choiceColumnWidth}%`,
            }"
          >
            <div v-html="choiceTitle(choice)"></div>
          </div>
          <b-form-checkbox-group
            v-if="choices[idx]"
            v-model="choices[idx].categories"
            size="lg"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
            :style="{
              width: `${100 - choiceColumnWidth}%`,
            }"
          >
            <b-form-checkbox
              v-for="(category, c) in decision.categories"
              :key="`cat-checkbox-${c}`"
              :value="category"
              :aria-label="`${choiceTitle(choice)} ${category.name}`"
              class="multiselect-checkboxes"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0;
                margin: -48px 0 0 48px;
              "
              :style="{
                width: `${categoryCheckboxCellWidth}%`,
              }"
              @change="() => onClickMatrixCheckbox(idx, category)"
            ></b-form-checkbox>
          </b-form-checkbox-group>
        </div>
      </div>
      <!-- This div is just here to make additional room for the button since it has absolute positioning -->
      <div style="height: 60px;"/>
      <transition
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
      >
        <button
          class="btn-choice"
          style="position: absolute; right: 20px; bottom: 20px; width: 100px; font-size: 20px; font-weight: 500;"
          @click.prevent="onSubmitMatrix"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Select'"></span>
        </button>
      </transition>
    </div>
    <div v-else-if="decision.type && decision.type === 'matching'">
      <div
        style="
          display: flex;
          flex-flow: column nowrap;
        "
        :style="{
          'max-height': (decision.choiceBubbleMaxHeightOverride
            ? `calc(${decision.choiceBubbleMaxHeightOverride} - 48px)`
            : '452px'), /* 500px from .choice-bubble max - 48px from .choice-bubble padding/border */
          'min-height': (decision.choiceBubbleMinHeightOverride
            ? `calc(${decision.choiceBubbleMinHeightOverride} - 48px)`
            : undefined),
        }"
      >
        <!-- categories -->
        <div
          style="
            display: flex;
            align-items: center;
            overflow: auto;
            /* max-height: calc(50% - 2px); */
            flex: 1;
            margin: 0 0 4px;
          "
          :style="{
            'flex-direction': (decision.categoriesAsRows ? 'column' : 'row'),
            'flex-wrap': ((decision.categoriesWrapLimit > 1) ? 'wrap' : 'nowrap'),
            'justify-content': categoriesOverflow ? 'flex-start' : 'space-around',
            'height': (decision.categoriesAreaHeight || undefined),
          }"
        >
          <div
            v-for="(category, c) in decision.categories"
            :key="`cat-${c}`"
            style="
              margin: 0 8px 8px 0;
              flex-shrink: 0;
            "
            :style="{
              width: categoryWidth,
            }"
          >
            <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
            <div
              v-html="category.displayName || category.name || ''"
              style="
                font-size: 21px;
              "
            ></div>
            <draggable
              class="cat-drag"
              :style="catDragStyle"
              :list="matchingState[c]"
              group="choices"
              ghost-class="cat-drag-ghost"
              ref="catDrags"
            >
              <button
                v-for="(choice, i) in matchingState[c]"
                :key="`cat-${c}-choice-${i}`"
                class="cat-drag-item btn-choice"
                :class="buttonClass"
                style="font-size: 13px;"
                :style="{
                  height: nonDefaultChoiceHeight,
                  'line-height': nonDefaultChoiceHeight ? '1.15' : undefined,
                  position: (choiceImage(choice) && choice.showTitle) ? 'relative' : undefined,
                  overflow: (choiceImage(choice) && choice.showTitle) ? 'visible' : undefined,
                  'margin-bottom': (choiceImage(choice) && choice.showTitle) ? '50px' : undefined,
                  'margin-right': ((categoriesChoicesWrapLimit > 1) ? '4px' : ''),
                  'margin-left': ((categoriesChoicesWrapLimit > 1) ? '4px' : ''),
                  width: categoriesChoiceWidth,
                }"
              >
                <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
                <h3
                  v-if="!(choiceImage(choice))"
                  v-html="choiceTitle(choice)"
                  :style="`${(!(survey) && decision.displayOneLineChoices) ? '' : 'padding: 3px;'}${nonDefaultChoiceHeight ? ` line-height: 1.2; position: unset;` : ''}`"
                ></h3>
                <img
                  v-if="choiceImage(choice)"
                  :src="choiceImage(choice)"
                  style="width: 100%; height: 100%; object-fit: contain;"/>
                <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
                <h3
                  v-if="choiceImage(choice) && choice.showTitle"
                  v-html="choiceTitle(choice)"
                  :style="`position: absolute; top: calc(100% + 6px); line-height: 130%; width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
                ></h3>
              </button>
            </draggable>
          </div>
        </div>
        <!-- choices -->
        <div
          style="
            overflow: auto;
            /* max-height: calc(50% - 2px); */
            flex: 1;
          "
          :style="{
            'min-height': decision.choicesAreaHeight || '127px',
            height: decision.choicesAreaHeight || undefined,
          }"
        >
          <draggable
            class="cat-drag"
            :style="{
              'min-height': decision.choicesAreaHeight || '127px',
            }"
            :list="unmatchingState"
            group="choices"
            ghost-class="cat-drag-ghost"
          >
            <button
              v-for="(choice, i) in unmatchingState"
              :key="`nocat-choice-${i}`"
              class="cat-drag-item btn-choice"
              :class="buttonClass"
              style="font-size: 13px;"
              :style="{
                height: nonDefaultChoiceHeight,
                'line-height': nonDefaultChoiceHeight ? '1.15' : undefined,
                position: (choiceImage(choice) && choice.showTitle) ? 'relative' : undefined,
                overflow: (choiceImage(choice) && choice.showTitle) ? 'visible' : undefined,
                'margin-bottom': (choiceImage(choice) && choice.showTitle) ? '50px' : undefined,
                'margin-right': ((decision.choicesWrapLimit > 1) ? '4px' : ''),
                'margin-left': ((decision.choicesWrapLimit > 1) ? '4px' : ''),
                width: choiceWidth,
              }"
            >
              <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
              <h3
                v-if="!(choiceImage(choice))"
                v-html="choiceTitle(choice)"
                :style="`${(!(survey) && decision.displayOneLineChoices) ? '' : 'padding: 3px;'}${nonDefaultChoiceHeight ? ` line-height: 1.2; position: unset;` : ''}`"
              ></h3>
              <img
                v-if="choiceImage(choice)"
                :src="choiceImage(choice)"
                style="width: 100%; height: 100%; object-fit: contain;"/>
              <!-- Never use v-html with end-user generated content, because it's a vector for XSS attacks -->
              <h3
                v-if="choiceImage(choice) && choice.showTitle"
                v-html="choiceTitle(choice)"
                :style="`position: absolute; top: calc(100% + 6px); line-height: 130%; width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
              ></h3>
            </button>
          </draggable>
          <!-- submit button -->
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <button
              v-if="unmatchingState.length < 1"
              autofocus
              class="btn-choice"
              style="
                position: absolute;
                right: 20px;
                bottom: 20px;
                width: 160px;
                height: 75px;
                padding: 1px;
                line-height: 1.13;
                font-size: 30px;
                font-weight: 500;
              "
              @click.prevent="onSubmitMatching"
              ref="matchingSubmitButton"
            >
              <span v-html="submitButtonText ? submitButtonText : 'Submit Matches'"></span>
            </button>
          </transition>
        </div>
      </div>
    </div>
    <div
      v-else-if="choiceDisplayType === 'list'"
      :class="containerClass"
      :style="containerStyle"
    >
      <button
        :class="`btn-choice ${buttonClass}`"
        :style="{
          width: (choiceWidth ? choiceWidth : undefined),
          position: ((choiceImage(choice) && choice.showTitle) ? 'relative' : undefined),
          overflow: ((choiceImage(choice) && choice.showTitle) ? 'visible' : undefined),
          'margin-bottom': ((choiceImage(choice) && choice.showTitle) ? '50px' : undefined),
          height: nonDefaultChoiceHeight,
          padding: ((!dynamicHeightChoices && (choiceHeightOverride && choiceHeightOverride < 32)) ? `1px ${15 * (choiceHeightOverride / 32)}px` : undefined),
          'margin-top': (choiceStartsFocused ? '16px' : undefined),
        }"
        style="
          padding-top: 0;
          padding-bottom: 0;
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
        "
        v-for="(choice, i) in displayChoices"
        :key="`choice-${i}`"
        @click.prevent="onClickChoice({ choice, selectedChoiceIndex: i })"
        :tabindex="i + 1"
        v-focus="choice.startsFocused ? true : (!disableAutofocus ? i === 0 : false)"
      >
        <!--
          Never use v-html with end-user generated content, because it's a vector for XSS attacks
          This is what the following line used to be:
          <h3>{{ choice.title }}</h3>
        -->
        <h3
          v-if="!(choiceImage(choice))"
          v-html="choiceTitle(choice)"
          :style="`${(!(survey) && decision.displayOneLineChoices) ? '' : 'padding: 3px;'}`"
        ></h3>
        <p
          v-if="!(choiceImage(choice)) && !(survey) && showCost && !(choice.hideCost) && !isNaN(parseFloat(choice.displayedCost || choice.cashAdjustment || 0))"
          style="position: absolute; right: 15px; bottom: 5px;"
        >
          COST: <span class="currency">{{ -parseFloat((choice.displayedCost != undefined) ? choice.displayedCost : choice.cashAdjustment) || 0 | currency }}</span>
        </p>
        <img
          v-if="choiceImage(choice)"
          :src="choiceImage(choice)"
          style="width: 100%; height: 100%; object-fit: contain;"/>
        <!--
          Never use v-html with end-user generated content, because it's a vector for XSS attacks
        -->
        <h3
          v-if="choiceImage(choice) && choice.showTitle"
          v-html="choiceTitle(choice)"
          :style="`position: absolute; top: calc(100% + 5px); width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
        ></h3>
      </button>
    </div>
    <div
      v-else
      :class="containerClass"
      :style="containerStyle"
    > <!-- TODO: above css height transition doesn't seem to be working. get it working later. -->
      <div style="overflow-x: hidden;">
        <transition :enter-active-class="enterActiveClass" :leave-active-class="leaveActiveClass">
          <div v-if="showCurrentChoice" style="width: 100%;">
            <div v-if="!(decision.hideChoiceHeader)" style="width: 100%;">
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
              -->
              <h3
                v-if="!(choiceImage(currentChoice))"
                v-html="choiceTitle(currentChoice)"
                style="text-align: center; width: 100%;"
              ></h3>
              <p
                v-if="!(choiceImage(currentChoice)) && !(survey) && showCost && !(currentChoice.hideCost) && !isNaN(parseFloat(currentChoice.displayedCost || currentChoice.cashAdjustment || 0))"
                style="position: absolute; right: 15px; top: 15px;"
              >
                COST: <span class="currency">{{ -parseFloat((currentChoice.displayedCost != undefined) ? currentChoice.displayedCost : currentChoice.cashAdjustment) || 0 | currency }}</span>
              </p>
              <img
                v-if="choiceImage(currentChoice)"
                :src="choiceImage(currentChoice)"
                style="width: 100%; height: 100%; object-fit: contain;"/>
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
              -->
              <h3
                v-if="choiceImage(currentChoice) && currentChoice.showTitle"
                v-html="choiceTitle(currentChoice)"
                :style="`position: absolute; top: calc(100% + 5px); width: 100%; color: ${(starfighter) ? 'black' : 'white'};`"
              ></h3>
            </div>
            <h5
              :style="{
                'text-align': 'center',
                'font-size': (decision.hideChoiceHeader ? '16px' : undefined),
              }"
            >
              (Option {{currentChoiceIndex + 1}} of {{displayChoices.length}})
            </h5>
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
            -->
            <p
              v-if="currentChoice.description"
              v-html="choiceDescription(currentChoice)"
              style="font-size: 24px; overflow-y: auto;"
              :style="{
                'max-height': (decision.choiceBubbleMinHeightOverride
                  ? `calc(${decision.hideChoiceHeader ? 0.66 : 0.54} * ${decision.choiceBubbleMinHeightOverride})`
                  : '195px'),
              }"
            >
            </p>
          </div>
        </transition>
      </div>
      <div
        style="width: 100%; padding: 0 8px; display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;"
      >
        <button
          class="btn"
          @click.prevent="prevChoice"
          style="padding: 12px; position: relative;"
        >
          <img
            :src="resolveAssetPath('ArrowL_Tall.png', 'ui/customer')"
            :style="{
              height: '27px',
              width: '90%',
              'object-fit': 'fill',
            }"
          />
          <tooltip
            target="choiceCarouselLeftArrow"
          >
          </tooltip>
        </button>
        <button
          class="btn"
          @click.prevent="onClickChoice({ choice: currentChoice, selectedChoiceIndex: currentChoiceIndex })"
          style="font-size: 28px; padding: 20px; position: relative;"
        >
          <span v-html="submitButtonText ? submitButtonText : 'Reply'"></span>
          <tooltip
            target="choiceCarouselSelect"
          >
          </tooltip>
        </button>
        <button
          class="btn"
          @click.prevent="nextChoice"
          style="padding: 12px; position: relative;"
        >
          <img
            :src="resolveAssetPath('ArrowL_Tall.png', 'ui/customer')"
            :style="{
              height: '27px',
              width: '90%',
              'object-fit': 'fill',
              transform: 'rotateY(180deg)',
            }"
          />
          <tooltip
            target="choiceCarouselRightArrow"
          >
          </tooltip>
        </button>
      </div>
    </div>
  </div>
  <tooltip
    target="choices"
  >
  </tooltip>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import ChoiceSlider from './ChoiceSlider';
import Tooltip from './Tooltip';
import { handleIFrames } from '../../../utils/utils';

export default {
  props: {
    decision: { type: Object },
    submitButtonText: { type: String },
    right: { type: Boolean },
    showCost: { type: Boolean },
    dynamicHeightChoices: { type: Boolean },
    choiceHeightOverride: { type: Number },
    choiceWidthOverride: { type: Number },
    /** array of indices to indicate a special desired order */
    shuffledChoiceOrder: { type: Array, default: () => [] },
    pastChoices: { type: Array, default: () => [] }
  },
  components: {
    ChoiceSlider,
    Tooltip,
    draggable,
  },
  data() {
    return {
      disableAutofocus: true,
      currentChoiceIndex: 0, // used by carousel display type
      showCurrentChoice: true,
      enterActiveClass: 'animated fadeInRight',
      leaveActiveClass: 'animated fadeOutLeft',
      enableChoiceInputChangeSound: false,
      /** choices assigned to categories, 2D array */
      matchingState: [],
      /** choices not yet assigned to categories, 1D array */
      unmatchingState: [],
      categoriesMinHeight: '',
      slidersBlank: [],
      choices: []
    };
  },
  computed: {
    ...mapGetters([
      'activeClass',
      'game',
      'selectedAvatar',
      'interpolateRegex',
      'replacements',
      'starfighter',
      'native'
    ]),
    choiceStartsFocused() {
      return this.decision && this.decision.choices && this.decision.choices.length
        && this.decision.choices.some(c => c.startsFocused);
    },
    choiceDisplayType() {
      if (this.decision.type !== 'choice') {
        return 'list';
      }
      if (!(this.decision.preventChoiceDisplayTypeOverride)
        && this.activeClass && this.activeClass.choiceDisplayTypeOverride
        && this.activeClass.choiceDisplayTypeOverride !== 'Do Not Force') {
        switch (this.activeClass.choiceDisplayTypeOverride) {
          case 'List': return 'list';
          case 'Carousel': return 'carousel';
          default: return 'list';
        }
      }
      if (!(this.decision.choiceDisplayType)) return 'list';
      return this.decision.choiceDisplayType;
    },
    currentChoice() {
      return this.displayChoices[this.currentChoiceIndex];
    },
    shuffledChoices() {
      if (this.shuffledChoiceOrder && this.shuffledChoiceOrder.length
        && this.shuffledChoiceOrder.length === this.decision.choices.length) {
        return this.decision.choices.map(
          (ch, index) => this.decision.choices[this.shuffledChoiceOrder[index]]
        );
      }
      return this.shuffle(this.decision.choices);
    },
    displayChoices() {
      if (this.decision.forceRandomChoiceOrder
        || (!(this.decision.preventRandomChoiceOrder)
          && (!(this.survey || this.scale || this.decision.feedback) // these default to prevent random choice order
            && this.activeClass && this.activeClass.randomChoiceOrder))) {
        return this.shuffledChoices;
      }
      return this.decision.choices;
    },
    options() {
      // eslint-disable-next-line arrow-body-style
      return this.displayChoices.map((choice) => {
        return {
          html: `${this.choiceTitle(choice)}`,
          disabled: (this.decision.multiselectMaxChoices
            ? (!(this.choices.includes(choice)) && this.choices.length === this.decision.multiselectMaxChoices)
            : false),
          value: choice
        };
      });
    },
    containerClass() {
      if (this.survey) {
        return 'choice-bubble-buttons-survey';
      }
      if (this.choiceDisplayType === 'list') {
        if (this.decision.choices.some(c => c.image)) {
          return 'choice-bubble-buttons-image';
        }
        if (!(this.decision.displayOneLineChoices)) {
          return 'choice-bubble-buttons-flex';
        }
      }
      return 'choice-bubble-buttons';
    },
    containerStyle() {
      const s = {
        'max-height': (this.decision.choiceBubbleMaxHeightOverride ? this.decision.choiceBubbleMaxHeightOverride : undefined),
        'min-height': (this.decision.choiceBubbleMinHeightOverride
          ? `calc(${this.decision.choiceBubbleMinHeightOverride} - 48px)`
          : undefined
        ),
      };
      if (this.choiceDisplayType === 'carousel') { // implicitly also checks that decision type is 'choice'
        s.color = (this.starfighter) ? 'black' : 'white';
        s.overflow = 'visible';
        s.transition = 'height 1s ease-in-out';
        if (this.decision.choiceBubbleMinHeightOverride) {
          s.display = 'flex';
          s['flex-flow'] = 'column nowrap';
          s['justify-content'] = 'space-between';
          s['align-items'] = 'center';
        }
      }
      return s;
    },
    buttonClass() {
      if (this.survey) {
        if (this.decision.choices.some(c => c.image)) {
          return 'choice-btn-survey choice-btn-image';
        }
        return 'choice-btn-survey';
      }
      if (this.choiceDisplayType === 'list') {
        if (this.decision.choices.some(c => c.image)) {
          return 'choice-btn-image';
        }
        if (!(this.decision.displayOneLineChoices)) {
          return 'choice-btn-flex';
        }
      }
      return 'choice-btn';
    },
    /** only set if a non-default height is being used (e.g. Dynamic Choice Height or Choice Height Override) */
    nonDefaultChoiceHeight() {
      if (this.dynamicHeightChoices) {
        return 'fit-content';
      } else if (this.choiceHeightOverride) {
        return `${this.choiceHeightOverride}px`;
      }
      return undefined;
    },
    choiceWidth() {
      if (this.choiceWidthOverride) {
        return `${this.choiceWidthOverride}px`;
      } else if (this.survey && this.decision.equalSizedChoices) {
        return `calc(${Math.floor(100 / this.displayChoices.length)}% - 10px)`;
      } else if (this.matching) {
        if (this.decision.choicesWrapLimit && this.decision.choicesWrapLimit >= 1) {
          return `calc(${Math.floor(100 / this.decision.choicesWrapLimit)}% - 8px)`;
        }
        return '100%';
      }
      return undefined;
    },
    choiceColumnWidth() { // for scale decisions and matrix decisions
      return this.decision.choiceColumnWidthPercent
        ? this.decision.choiceColumnWidthPercent
        : (Math.round(10000 / (this.decision.categories.length + 1)) / 100);
    },
    categoryColumnWidth() { // for scale decisions and matrix decisions
      return this.decision.choiceColumnWidthPercent
        ? (Math.round(
          100 * (100 - this.decision.choiceColumnWidthPercent) / this.decision.categories.length
        ) / 100)
        : (Math.round(10000 / (this.decision.categories.length + 1)) / 100);
    },
    categoryCheckboxCellWidth() { // for scale decisions and matrix decisions
      return Math.round(10000 / this.decision.categories.length) / 100;
    },
    categoriesChoiceWidth() {
      if (this.categoriesChoicesWrapLimit && this.categoriesChoicesWrapLimit >= 1) {
        return `calc(${Math.floor(100 / this.categoriesChoicesWrapLimit)}% - 8px)`;
      }
      return '100%';
    },
    categoryWidth() {
      if (this.matching) {
        if (this.decision.categoriesWrapLimit && this.decision.categoriesWrapLimit >= 1) {
          return `calc(${Math.floor(100 / this.decision.categoriesWrapLimit)}% - 8px)`;
        }
        return this.decision.categoriesAsRows ? 'calc(100% - 8px)' : 'calc(33% - 8px)';
      }
      return undefined;
    },
    categoriesChoicesWrapLimit() {
      if (this.decision.categoriesChoicesWrapLimit) {
        return this.decision.categoriesChoicesWrapLimit;
      }
      if (this.decision.categoriesAsRows) {
        return this.decision.choicesWrapLimit;
      }
      if (
        this.decision.categoriesWrapLimit && this.decision.categoriesWrapLimit >= 1
        && this.decision.choicesWrapLimit && this.decision.choicesWrapLimit > 1
      ) {
        return Math.floor(this.decision.choicesWrapLimit / this.decision.categoriesWrapLimit);
      }
      return this.decision.choicesWrapLimit;
    },
    catDragStyle() {
      const style = {};

      if (this.decision.categoriesAsRows) {
        style.display = 'flex';
        style['flex-flow'] = 'row wrap';
      }

      style['min-height'] = this.categoriesMinHeight;

      return style;
    },
    categoriesOverflow() {
      return this.decision.categories && !(this.decision.categoriesAsRows) && this.decision.categories.length > 3;
    },
    survey() {
      return this.decision.type && this.decision.type === 'survey';
    },
    matching() {
      return this.decision.type && this.decision.type === 'matching';
    },
    scale() {
      return this.decision.type && this.decision.type === 'scale';
    },
    checkboxGroupStyle() {
      if (this.native) {
        return {
          color: 'white',
        };
      }
      return '';
    }
  },
  methods: {
    // $emit 'input' { choice, selectedChoiceIndex }
    ...mapActions([
      'playSound',
    ]),
    playChoiceInput() {
      const sound = (this.choiceDisplayType === 'carousel' && !(this.decision.choiceInputChangeSound))
        ? this.game.arrowButtonSound
        : this.decision.choiceInputChangeSound;
      if (this.enableChoiceInputChangeSound && sound) {
        this.playSound({ sound });
      }
    },
    playChoiceInputOff() {
      if (this.enableChoiceInputChangeSound && (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound)) {
        this.playSound({ sound: (this.decision.choiceInputOffSound || this.decision.choiceInputChangeSound) });
      }
    },
    playClick() {
      this.playSound({
        sound:
          this.decision.choiceSelectButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
      });
    },
    onSliderInput(index) {
      if (this.slidersBlank && this.slidersBlank.length > index && index >= 0 && this.slidersBlank[index]) {
        this.$set(this.slidersBlank, index, false);
      }
      this.playChoiceInput();
    },
    onClickMatrixCheckbox(idx, category) {
      if (this.choices[idx].categories.includes(category)) {
        this.playChoiceInput();
      } else {
        this.playChoiceInputOff();
      }
    },
    async onSubmitSliders() {
      const data = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const slider of this.$refs.choiceSlider) {
        const obj = Object.assign(
          { sliderValue: slider.value, valueString: slider.valueString },
          slider.choice
        );
        data.push(obj);
      }

      this.onClickChoice(data);
    },
    async onSubmitScale() {
      // console.log(this.choices);
      this.onClickChoice(this.choices);
    },
    async onSubmitMatrix() {
      // console.log(this.choices);
      this.onClickChoice(this.choices);
    },
    async onSubmitMatching() {
      const data = [];

      this.matchingState.forEach((cat, index) => {
        const category = this.decision.categories[index];
        cat.forEach((choice) => {
          const copy = Object.assign(
            {},
            choice
          );
          copy.category = {};
          Object.assign(copy.category, category);
          data.push(copy);
        });
      });

      this.onClickChoice(data);
    },
    async onClickChoice(data) {
      this.enableChoiceInputChangeSound = false;
      const d = (data != null) ? data : this.choices;
      this.playClick();
      await new Promise(resolve => setTimeout(resolve, 250));
      this.$emit('input', d);
    },
    async nextChoice() {
      this.enterActiveClass = 'animated fadeInRight';
      this.leaveActiveClass = 'animated fadeOutLeft';
      await Vue.nextTick();
      this.showCurrentChoice = false; // animate out
      await new Promise(resolve => setTimeout(resolve, 300));
      this.currentChoiceIndex = (this.currentChoiceIndex + 1) % this.displayChoices.length;
      this.showCurrentChoice = true; // animate in
    },
    async prevChoice() {
      this.enterActiveClass = 'animated fadeInLeft';
      this.leaveActiveClass = 'animated fadeOutRight';
      await Vue.nextTick();
      this.showCurrentChoice = false; // animate out
      await new Promise(resolve => setTimeout(resolve, 300));
      this.currentChoiceIndex -= 1;
      if (this.currentChoiceIndex < 0) this.currentChoiceIndex = this.displayChoices.length - 1;
      this.showCurrentChoice = true; // animate in
    },
    shuffle(array) {
      // ***
      // Fisher-Yates JS implementation from: https://stackoverflow.com/a/2450976
      // ***
      let currentIndex = array.length;
      let temporaryValue;
      let randomIndex;
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    },
    choiceImage(choice) {
      if (choice.playerVariantImage) {
        const variant =
          this.selectedAvatar.imageVariants.find(v => v.name === choice.playerVariantImage);
        if (variant) {
          return this.resolveAssetPath(variant.image, 'characters');
        }
      }

      if (choice.image) {
        return this.resolveAssetPath(choice.image, 'images');
      }

      return null;
    },
    choiceTitle(choice) {
      return (choice && choice.title)
        ? (choice.title.replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || ''))
        : '';
    },
    choiceDescription(choice) {
      return (choice && choice.description)
        ? (choice.description.replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || ''))
        : '';
    },
    log(evt) {
      console.log(evt);
    },
  },
  watch: {
    async pastChoices(newValue) {
      const old = this.enableChoiceInputChangeSound;
      this.enableChoiceInputChangeSound = false;
      this.choices = [...newValue];
      await this.$nextTick();
      this.enableChoiceInputChangeSound = old;
    },
    choices(newValue, oldValue) {
      if (newValue && oldValue && oldValue.length != null && newValue.length < oldValue.length) {
        this.playChoiceInputOff();
      } else {
        this.playChoiceInput();
      }
    },
    currentChoiceIndex() {
      this.playChoiceInput();
    },
    async matchingState() {
      this.playChoiceInput();
      // console.log(this.$refs.catDrags);
      this.categoriesMinHeight = ''; // needed to let the min shrink when using catDrags to size
      if (this.$refs.catDrags && this.$refs.catDrags.length) {
        await this.$nextTick();
        const maxClientHeight = this.$refs.catDrags.reduce(
          (acc, curr) => Math.max(acc, curr.$el.clientHeight),
          0,
        );
        this.categoriesMinHeight = `${maxClientHeight}px`;
        if (this.decision.categoryMinHeight) {
          this.categoriesMinHeight = `max(${this.categoriesMinHeight}, ${this.decision.categoryMinHeight})`;
        }
      } else if (this.decision.categoryMinHeight) {
        this.categoriesMinHeight = this.decision.categoryMinHeight;
      }

      if (this.unmatchingState && this.unmatchingState.length < 1) {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$refs.matchingSubmitButton.focus();
      }
    },
  },
  async mounted() {
    this.choices = [...this.pastChoices];
    if (this.decision.type === 'matching') {
      if (this.decision.categories && this.decision.categories.length) {
        this.matchingState = this.decision.categories.map(() => []);
      }
      // restore matchingState/unmatchingState when going back from confirm
      if (this.pastChoices && this.pastChoices.length) {
        this.pastChoices.forEach((choice) => {
          if (
            choice.category && choice.category._id && this.decision.categories && this.decision.categories.length
          ) {
            const catIndex = this.decision.categories.findIndex(({ _id }) => `${_id}` === `${choice.category._id}`);
            if (catIndex >= 0) {
              this.matchingState[catIndex].push(choice);
            }
          } else {
            this.unmatchingState.push(choice);
          }
        });
      } else {
        this.unmatchingState.push(...(this.displayChoices));
      }
    } else if (this.decision.type === 'sliders') {
      this.slidersBlank = this.displayChoices.map(c => c.sliderStartBlank);
    } else if (this.decision.type === 'scale') {
      if (!(this.choices) || this.choices.length < this.displayChoices.length) {
        this.choices = this.displayChoices.map(c => Object.assign({}, c));
      }
    } else if (this.decision.type === 'matrix') {
      if (!(this.choices) || this.choices.length < this.displayChoices.length) {
        this.choices = this.displayChoices.map(c => Object.assign({ categories: [] }, c));
      }
    }
    await Vue.nextTick();
    handleIFrames();
    this.enableChoiceInputChangeSound = true;
  }
};
</script>

<style lang="scss" scoped>
/deep/ .multiselect-checkboxes .custom-control-label::after {
  transform: translate(50%, 45%) scale(1.6);
}

/deep/ .multiselect-checkboxes .custom-control-label::before {
  transform: translate(50%, 45%) scale(1.6);
}

/deep/ .multiselect-checkboxes .custom-control-label {
  padding: 0 16px;
  font-size: 160%;
}

.fadeOutRight,
.fadeOutLeft {
  -webkit-animation-duration: 0.5s;
  -moz-animation-duration: 0.5s;
  -o-animation-duration: 0.5s;
  animation-duration: 0.5s;
}

.choice-bubble {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  width: 900px;
  max-height: 500px;
  padding: 20px;
}
.choice-bubble.sf {
  background-color: white;
  border: 4px solid black;
  border-radius: 24px;
  overflow: visible auto;
  z-index: 10;
}
.choice-bubble.matching {
  overflow: visible;
}
.choice-bubble.native {
  overflow: visible auto;
}
.choice-bubble.native.multi {
  overflow: unset;
}
.choice-bubble.carousel {
  overflow: visible;
}

.prompt {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: -8px;
  right: -8px;
  height: 60px;
  background-color: var(--neutralColor);
  color: white;
  text-align: center;
  transform: translateZ(-1px);
  // z-index: -1;
}
.prompt.sf {
  border: 2px solid black;
  font-size: 20px;
  top: -95px;
}
.prompt.native {
  border: 2px solid white;
  font-size: 25px;
  top: -95px;
}

// .choice-bubble::before {
//   content: '';
//   position: absolute;
//   left: -65px;
//   top: -30px;
//   background-color: white;
//   border: 4px solid black;
//   border-radius: 100px;
//   width: 50px;
//   height: 80px;
// }
// .choice-bubble::after {
//   content: '';
//   position: absolute;
//   left: -95px;
//   top: -55px;
//   background-color: white;
//   border: 4px solid black;
//   border-radius: 100px;
//   width: 25px;
//   height: 40px;
// }
// .choice-bubble.right::before {
//   left: unset;
//   right: -65px;
// }
// .choice-bubble.right::after {
//   left: unset;
//   right: -95px;
// }
.choice-bubble-buttons-survey {
  width: 100%;
  max-height: 615px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 8px;
  position: relative;
}
.choice-bubble-buttons-flex {
  width: 100%;
  max-height: 615px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
}
.choice-bubble-buttons-image {
  width: 100%;
  max-height: 615px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 5px;
  position: relative;
}
.choice-bubble-buttons {
  width: 100%;
  max-height: 615px;
  position: relative;
}
.choice-btn-survey {
  height: 80px;
  margin-left: 10px;
  margin-bottom: 10px;
  position: relative;
  padding: 5px 0 0;
  text-align: left;
  flex-grow: 1;
}
.choice-btn-flex {
  width: 48%;
  height: 160px;
  margin-left: 10px;
  margin-bottom: 10px;
  position: relative;
  padding: 15px;
  text-align: left;
}
.choice-btn-image {
  width: 30%;
  height: 250px;
  // margin-left: 3%;
  margin-bottom: 10px;
  padding: 1px;
  padding-top: 5px;
}
.choice-btn {
  width: 100%;
  height: 80px;
  margin-bottom: 10px;
  position: relative;
  padding: 15px;
  text-align: left;
  flex-shrink: 0;
}
.choice-btn:last-of-type {
  margin-bottom: 0px;
}
.choice-btn-survey h3 {
  font-size: 38px;
  width: 100%;
  text-align: center;
}
.choice-btn-flex h3 {
  position: absolute;
  left: 2.5%;
  top: 4px;
  font-size: 36px;
  margin: 0;
}
.choice-btn h3 {
  font-size: 42px;
  margin: 0;
}
.choice-btn-survey p {
  position: absolute;
  bottom: 0;
  right: 160px;
  margin: 0;
  font-size: 16px;
}
.choice-btn-flex p {
  position: absolute;
  bottom: 0;
  right: 160px;
  margin: 0;
  font-size: 16px;
}
.choice-btn p {
  position: absolute;
  bottom: 0;
  right: 160px;
  margin: 0;
  font-size: 20px;
}
.choice-btn-flex p span {
  font-size: 26px;
  // font-weight: bold;
}
.choice-btn p span {
  font-size: 32px;
  // font-weight: bold;
}
.choice-btn .btn-choice {
  margin: 0 inherit;
}
.choice-btn .btn-btn {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 140px;
  height: 70px;
  font-size: 28px;
  line-height: 30px;
  white-space: normal;
  padding-top: 2px;
}

/* matching */
.cat-drag {
  border: 1px solid grey;
  border-radius: 8px;
  padding: 8px 8px 1px;
  min-height: 110px;
  background-color: rgba(128, 128, 128, 0.25);
  box-shadow: inset 2px 2px grey;
}

.cat-drag-item {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  // should drag-item height always be dynamic height mode?
  // height: fit-content !important;
  padding: 6px 8px !important;
  margin: 0 4px 10px;
}

.cat-drag-item:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.cat-drag-ghost {
  content: '' !important;
  filter: none !important;
  background: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 1px !important;
  min-width: 1px !important;
  height: 16px !important;
  width: 16px !important;
  border: 2px dashed grey !important;
  // display: none;
}
// maybe use different ghost class for row- vs column- flowing draggables
</style>



// WEBPACK FOOTER //
// src/components/game/ui/ChoiceBubble.vue